import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { merge } from "rxjs";
import { TextButtonComponent } from "../shared/buttons/text-button/text-button.component";
import { NTSTranslatePipe } from "../pipe/nts-translation-pipe";
import { MasterAreaContainerComponent } from "../master-area-container/master-area-container.component";
import { SnapShotListContainerComponent } from "../snap-shot-list-container/snap-shot-list-container.component";

import type { MasterViewModelInterface, SnapShotListViewModelInterface, ViewModelEventDispatcherInterface } from '@nts/std/interfaces';

@UntilDestroy()
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'nts-navigation-panel',
    templateUrl: './navigation-panel.component.html',
    styleUrls: ['./navigation-panel.component.scss'],
    imports: [
    TextButtonComponent,
    NTSTranslatePipe,
    MasterAreaContainerComponent,
    SnapShotListContainerComponent
]
})
export class NavigationPanelComponent implements OnInit, OnDestroy {

  @Input() masterViewModel: MasterViewModelInterface;
  @Input() eventDispatcher: ViewModelEventDispatcherInterface;
  @Input() snapShotListViewModel: SnapShotListViewModelInterface;

  @Output() onNavigationPanelCollapsed = new EventEmitter();
  @Output() onMasterAreaSelected = new EventEmitter();
  @Output() onSnapShotSelected = new EventEmitter();

  constructor(
    private _cd: ChangeDetectorRef
  ) { }

  ngOnDestroy(): void {
    this.eventDispatcher?.onDestroy();
    this.masterViewModel?.onDestroy();
    this.snapShotListViewModel?.onDestroy();
    this.onNavigationPanelCollapsed?.complete();
    this.onMasterAreaSelected?.complete();
    this.onSnapShotSelected?.complete();

    this.eventDispatcher = null;
    this.masterViewModel = null;
    this.snapShotListViewModel = null;
    this.onNavigationPanelCollapsed = null;
    this.onMasterAreaSelected = null;
    this.onSnapShotSelected = null;
  }

  ngOnInit() {

    merge(
      this.eventDispatcher.onSnapShotSelected,
      this.eventDispatcher.onMasterAreaSelected,
      this.eventDispatcher.onNavigationPanelCollapsed,
    ).pipe(untilDestroyed(this)).subscribe(
      () => this._cd.detectChanges()
    );
  }
}
